// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-membership-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
}
.buy-membership-container .membership-card {
  position: relative;
  height: 100%;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-shadow: var(--shadow-md);
  overflow: hidden;
}
.buy-membership-container .membership-card:hover {
  transform: translateY(-6px);
  box-shadow: var(--shadow-float);
  background: rgba(255, 255, 255, 0.9);
}
.buy-membership-container .membership-card.current {
  border: 2px solid var(--float-primary);
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.15);
}
.buy-membership-container .membership-card.current:hover {
  box-shadow: 0 12px 28px rgba(79, 70, 229, 0.25);
}
.buy-membership-container .membership-card.large .ant-card-body {
  padding: 32px;
}
.buy-membership-container .membership-card .current-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: var(--gradient-primary);
  color: white;
  padding: 6px 20px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
  border-radius: 0 16px 0 16px;
  z-index: 10;
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3);
}
.buy-membership-container .calculation-formula {
  margin-top: 24px;
  padding: 20px;
  background: rgba(248, 250, 252, 0.6);
  backdrop-filter: blur(8px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.5);
}
.buy-membership-container .calculation-formula .formula-content {
  font-size: 13px;
  line-height: 1.8;
  font-family: 'JetBrains Mono', Consolas, monospace;
  white-space: pre-line;
}
.buy-membership-container .calculation-formula .formula-content .formula-line.header {
  color: var(--float-primary);
  font-weight: 600;
  margin-top: 12px;
}
.buy-membership-container .calculation-formula .formula-content .formula-line.header:first-child {
  margin-top: 0;
}
.buy-membership-container .calculation-formula .formula-content .formula-line.content {
  color: #64748b;
  padding-left: 16px;
  border-left: 2px solid rgba(79, 70, 229, 0.1);
  margin-left: 4px;
}
@media (max-width: 768px) {
  .buy-membership-container {
    padding: 16px;
  }
  .buy-membership-container .ant-col {
    margin-bottom: 16px;
  }
  .buy-membership-container .membership-card.large .ant-card-body {
    padding: 20px;
  }
  .buy-membership-container .calculation-formula .formula-content {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/BuyMembership.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AACF;AAJA;EAMI,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,4BAAA;EACA,gBAAA;AACJ;AACI;EACE,2BAAA;EACA,+BAAA;EACA,oCAAA;AACN;AAEI;EACE,sCAAA;EACA,8CAAA;AAAN;AAEM;EACE,+CAAA;AAAR;AAII;EAEI,aAAA;AAHR;AA9BA;EAsCM,kBAAA;EACA,MAAA;EACA,QAAA;EACA,mCAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,4BAAA;EACA,WAAA;EACA,6CAAA;AALN;AA5CA;EAuDI,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,0BAAA;EACA,mBAAA;EACA,0CAAA;AARJ;AApDA;EA+DM,eAAA;EACA,gBAAA;EACA,kDAAA;EACA,qBAAA;AARN;AAWQ;EACE,2BAAA;EACA,gBAAA;EACA,gBAAA;AATV;AAWU;EACE,aAAA;AATZ;AAaQ;EACE,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,gBAAA;AAXV;AAiBE;EAAA;IACE,aAAA;EAdF;EAaA;IAII,mBAAA;EAdJ;EAkBI;IACE,aAAA;EAhBN;EAOA;IAeM,eAAA;EAnBN;AACF","sourcesContent":[".buy-membership-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n\n  .membership-card {\n    position: relative;\n    height: 100%;\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(12px);\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    box-shadow: var(--shadow-md);\n    overflow: hidden;\n\n    &:hover {\n      transform: translateY(-6px);\n      box-shadow: var(--shadow-float);\n      background: rgba(255, 255, 255, 0.9);\n    }\n\n    &.current {\n      border: 2px solid var(--float-primary);\n      box-shadow: 0 8px 20px rgba(79, 70, 229, 0.15);\n\n      &:hover {\n        box-shadow: 0 12px 28px rgba(79, 70, 229, 0.25);\n      }\n    }\n\n    &.large {\n      .ant-card-body {\n        padding: 32px;\n      }\n    }\n\n    .current-badge {\n      position: absolute;\n      top: 0;\n      right: 0;\n      background: var(--gradient-primary);\n      color: white;\n      padding: 6px 20px;\n      font-size: 12px;\n      font-weight: 700;\n      letter-spacing: 0.5px;\n      border-radius: 0 16px 0 16px;\n      z-index: 10;\n      box-shadow: 0 4px 10px rgba(79, 70, 229, 0.3);\n    }\n  }\n\n  // 计算公式显示样式\n  .calculation-formula {\n    margin-top: 24px;\n    padding: 20px;\n    background: rgba(248, 250, 252, 0.6);\n    backdrop-filter: blur(8px);\n    border-radius: 12px;\n    border: 1px solid rgba(255, 255, 255, 0.5);\n\n    .formula-content {\n      font-size: 13px;\n      line-height: 1.8;\n      font-family: 'JetBrains Mono', Consolas, monospace;\n      white-space: pre-line;\n\n      .formula-line {\n        &.header {\n          color: var(--float-primary);\n          font-weight: 600;\n          margin-top: 12px;\n          \n          &:first-child {\n            margin-top: 0;\n          }\n        }\n\n        &.content {\n          color: #64748b;\n          padding-left: 16px;\n          border-left: 2px solid rgba(79, 70, 229, 0.1);\n          margin-left: 4px;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n\n    .ant-col {\n      margin-bottom: 16px;\n    }\n\n    .membership-card {\n      &.large .ant-card-body {\n        padding: 20px;\n      }\n    }\n\n    .calculation-formula {\n      .formula-content {\n        font-size: 12px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
